import { getShareKey } from "@src/auth/auth-utils";
import { ROUTES } from "@src/common/constants";
import { fetchActiveWhiteboardQueryOptions } from "@src/components/board/queries/fetch-active-whiteboard";
import { parseWhiteboardDocumentId } from "@src/components/collaboration/document-id";
import { queryClient } from "@src/query-client";

export async function whiteboardPageLoader(id: string, url: string) {
	// Accept typed (`Whiteboard-…`) or raw ids; GraphQL uses the raw segment.
	const whiteboardId = parseWhiteboardDocumentId(id);
	const searchParams = extractSearchParamsFromWhiteboardUrl(url);
	const shareKey = getShareKey(searchParams);

	queryClient.prefetchQuery(
		fetchActiveWhiteboardQueryOptions(whiteboardId, shareKey),
	);

	return {
		whiteboardId,
	};
}

function extractSearchParamsFromWhiteboardUrl(url: string): string {
	if (!url.includes(ROUTES.whiteboards)) {
		return "";
	}

	try {
		const urlObj = new URL(url);
		const searchParams = urlObj.searchParams;

		if (searchParams.toString()) {
			return `?${searchParams.toString()}`;
		}

		return "";
	} catch {
		return "";
	}
}
